import { render, staticRenderFns } from "./VenueSpecialistReports.vue?vue&type=template&id=918e3b4c&"
import script from "./VenueSpecialistReports.vue?vue&type=script&lang=js&"
export * from "./VenueSpecialistReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports